import React from "react";
import {useParams, NavLink} from "react-router";
import {ArrowBackIos} from "@mui/icons-material";
import {Button, Paper, Stack, Box, Typography} from "@mui/material";
import UserAddressName from "../../components/userAddress/UserAddressDetail/UserAddressName.tsx";
import {useLocationFormState} from "../../components/userAddress/UserAddressForm/UserAddressUpdateForm";
import UserAddressUpdateFormProvider from "../../components/userAddress/UserAddressForm/UserAddressUpdateFormProvider";
import {useTitle} from 'react-use';
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

const UserAddressUpdateEditPage = () => {
    
    useTitle(t`Update User Address`);

    const { userAddressId: id } = useParams();
    
    return (
        <Box data-testid="UserAddress-update-form">
            <Paper sx={ { padding: "2em" } }>
                <Stack direction="column" spacing={1}>
                    <Typography
                        sx={ { flex: '1 1 100%' } }
                        variant="h6"
                        component="div"
                        data-testid="UserAddress-update-title"
                    >
                        <Trans>Edit User Address</Trans>:  <UserAddressName id={id}/>
                    </Typography>
                    <UserAddressUpdateFormProvider
                        id={id}
                        cancelButton={
                            <Button size="medium" variant="contained" color="inherit" startIcon={<ArrowBackIos />}
                                    component={NavLink}
                                    to=".."
                                    relative="path"
                                    viewTransition={true}
                            >
                                <Trans>Cancel</Trans>
                            </Button>
                        }
                        initialFormState={useLocationFormState}
                    />
                </Stack>
            </Paper>
        </Box>
    )
}

export default UserAddressUpdateEditPage;
